// debugpanel.js
export const DebugPanel = {
    enableDrag(element) {
        let el = element instanceof HTMLElement ? element : document.querySelector(".fs-debug-panel");
        if (!el) return;

        let pos = { x: 0, y: 0 };

        const onMouseDown = (e) => {
            pos = {
                x: e.clientX - el.offsetLeft,
                y: e.clientY - el.offsetTop
            };
            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", onMouseUp);
        };

        const onMouseMove = (e) => {
            el.style.left = (e.clientX - pos.x) + "px";
            el.style.top = (e.clientY - pos.y) + "px";
            el.style.right = "auto";
            el.style.bottom = "auto";
        };

        const onMouseUp = () => {
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
        };

        el.querySelector(".fs-debug-panel-header")?.addEventListener("mousedown", onMouseDown);
    }
};
